export const voucherMockData = [
  {
    id: 1,
    code: "SUMMIT2026",
    title: "Siloam Summit Special",
    discountType: "Percentage",
    discountValue: 25,
    expiryDate: "2026-12-31",
    isValid: true,
    usageLimit: 100,
    usedCount: 45
  },
  {
    id: 2,
    code: "HEALTHY100",
    title: "Flat Discount Medical",
    discountType: "Fixed",
    discountValue: 100000,
    expiryDate: "2026-06-15",
    isValid: true,
    usageLimit: 50,
    usedCount: 50
  },
  {
    id: 3,
    code: "EXPIRED50",
    title: "Ramadan Flash Sale",
    discountType: "Percentage",
    discountValue: 50,
    expiryDate: "2026-04-01",
    isValid: false,
    usageLimit: 200,
    usedCount: 200
  },
  {
    id: 4,
    code: "VIPGUEST",
    title: "VIP Invitation Voucher",
    discountType: "Percentage",
    discountValue: 100,
    expiryDate: "2026-08-20",
    isValid: true,
    usageLimit: 10,
    usedCount: 2
  },
  {
    id: 5,
    code: "EARLYBIRD",
    title: "Workshop Early Bird",
    discountType: "Fixed",
    discountValue: 75000,
    expiryDate: "2026-05-30",
    isValid: true,
    usageLimit: 30,
    usedCount: 12
  }
];